import * as React from "react";

// material-ui
import { Clear } from "@material-ui/icons";

export interface AssistantTabCardProps {
  bodyComponent: React.ReactNode;
  tooltipText: string;
  actionComponent?: React.ReactNode;
  onClear?: () => void;
}

export const AssistantTabCard = (props: AssistantTabCardProps) => {
  const { onClear, bodyComponent, tooltipText, actionComponent } = props;

  const canClearCard = !!onClear;
  const hasAction = !!actionComponent;
  return (
    <div className="cw-bg-white cw-shadow-cardContainer cw-relative cw-rounded-lg cw-mt-[16px]">
      <div className="cw-px-3 cw-pt-3 cw-flex cw-flex-1 cw-justify-around">
        <div className="cw-font-body cw-flex cw-flex-1 cw-items-center cw-h5 cw-text-xs cw-overflow-hidden cw-text-slate-standard">
          {tooltipText}
        </div>
        {canClearCard && (
          <Clear
            className="cw-cursor-pointer cw-fill-slate-lighter hover:cw-fill-slate-standard"
            onClick={onClear}
          />
        )}
      </div>

      <div className="cw-p-3">{bodyComponent}</div>

      {hasAction && (
        <>
          <div className="cw-border-0 cw-border-b cw-border-solid cw-border-gray-300" />
          <div className="cw-border-0 cw-border-t cw-p-3 cw-border-solid cw-border-gray-300">
            {actionComponent}
          </div>
        </>
      )}
    </div>
  );
};
